module.exports = __webpack_public_path__ + "img/geofenceExit.5509599b.svg";